import { NgModule } from '@angular/core';
import { WhiteLabelConfigService } from 'src/app/white-label/white-label-config.service';
import { FilterBreadcrumbItemsPipe } from './pipes/filter-breadcrumb-items.pipe';
import { whiteLabelInitProvider } from './white-label-init.provider';
import { whiteLabelInterceptorProvider } from './white-label-interceptor.provider';

@NgModule({
  imports: [
    FilterBreadcrumbItemsPipe,
  ],
  exports: [
    FilterBreadcrumbItemsPipe,
  ],
  declarations: [],
  providers: [
    WhiteLabelConfigService,
    whiteLabelInitProvider,
    whiteLabelInterceptorProvider,
  ],
})
export class WhiteLabelModule {}
